import MyContainer from "@/components/MyContainer";
import PickupForm from "@/pages/pickup/form/pickup-form";

export function CreatePickupPage() {
  return (
    <MyContainer title="Create Pickup" subtitle="Create a new pickup">
      <PickupForm mode="create" />
    </MyContainer>
  );
}
